export async function useErrorRedirect(code: number, toPath: string = '') {
  const router = useRouter()
  const route = useRoute()

  await router.push({
    path: `/${code}`,
    query: {
      ...route.query,
      from: route.path,
      to: toPath,
    },
  })
}
